import { render, staticRenderFns } from "./CheckboxTree.vue?vue&type=template&id=0b5cda40&"
import script from "./CheckboxTree.vue?vue&type=script&lang=js&"
export * from "./CheckboxTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports